const collaborators = (state = [], action) => {
  switch (action.type) {
    case 'COLLABORATORS_GET':
      return [...(action.data || [])];
      break;
  }
  return state;
};

export default collaborators;